<template>
  <div id="chart-line-item-item-box">
    <chart-title
      leftTitle="TQC售后出错类型"
      rightTitle="2022年12月 合计：99"
    ></chart-title>
    <date-change-card
      height="calc(100% - 30px)"
      @leftClick="leftClick"
      @rightClick="rightClick"
    >
    <div id="center_6" slot="main"/>
    </date-change-card>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
export default {
  mixins: [resize],
  name: "center_6",
  components: { ChartTitle,DateChangeCard },
  data() {
    return {
      chart: null,
    };
  },
  props: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("center_6"));
      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          right: "10%",
          top: "center",
          textStyle: {
            color: "#C0C4CC",
            fontSize: "10",
          },
        },
        color: [
          "#1158a7",
          "#4682B4",
          "#0983ff",
          "#59abf6",
          "#abd6fc",
          "#29beb9",
          "#3bffd0",
          "#22e4ff",
          "#40E0D0",
        ],
        series: [
          {
            name: "TQC售后出错类型",
            type: "pie",
            radius: "70%",
            right: "20%",
            bottom: "2%",
            data: [
              { value: 248, name: "尺寸出错" },
              { value: 735, name: "材料出错" },
              { value: 580, name: "颜色出错" },
              { value: 484, name: "结构出错" },
              { value: 100, name: "少开板件" },
              { value: 600, name: "拉槽出错" },
              { value: 484, name: "孔位出错" },
              { value: 100, name: "五金板件" },
              { value: 600, name: "其他出错" },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              formatter: "{b}：{@2012}",
              color:"#C0C4CC"
            },
          },
        ],
      });
    },
     //前一月
    leftClick() {
      console.log("leftClick");
    },
    //后一月
    rightClick() {
      console.log("rightClick");
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 31vh;
  #center_6 {
    height: 100%;
  }
}
</style>

